import { Injectable, NgModule } from '@angular/core';
import {
    DefaultFallbackStrategy,
    DefaultInterceptor,
    DefaultMissingHandler,
    FunctionalTranspiler,
    provideTranslocoTranspiler,
    TRANSLOCO_CONFIG,
    TRANSLOCO_FALLBACK_STRATEGY,
    TRANSLOCO_INTERCEPTOR,
    TRANSLOCO_LOADER,
    TRANSLOCO_MISSING_HANDLER,
    translocoConfig,
    TranslocoLoader,
    TranslocoModule
} from '@jsverse/transloco';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    async getTranslation(lang: string) {
        // Using webpack dynamic import for the translation files instructs webpack
        // to generate lazily loaded modules for our translation files during a production
        // build.  This generates a hash as part of the file name, which helps with busting
        // the cache that browsers often apply to seemingly static asset files (including
        // json files like this).
        const res = await import(`../../../assets/i18n/${lang}.json`);
        return res.default;
    }
}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        {
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: ['en', 'es'],
                defaultLang: 'en',
                fallbackLang: 'en',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode: environment.production
            })
        },
        { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
        provideTranslocoTranspiler(FunctionalTranspiler),
        { provide: TRANSLOCO_MISSING_HANDLER, useClass: DefaultMissingHandler },
        { provide: TRANSLOCO_INTERCEPTOR, useClass: DefaultInterceptor },
        {
            provide: TRANSLOCO_FALLBACK_STRATEGY,
            useClass: DefaultFallbackStrategy
        }
    ]
})
export class TranslocoRootModule {}
